<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>

        <div>
            <MultiSelect
             v-model="selected"
             @change="handleChangeSelect"
             :options="options" filter
             :optionLabel="optionLabel"
             placeholder="Selecione"
             :appendTo="appendTo"
             class="w-full">
                <template #option="slotProps">
                    <div class="flex items-center">
                        <div>{{ slotProps.option.label }}</div>
                    </div>
                </template>
            </MultiSelect>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import MultiSelect from 'primevue/multiselect';
import { ref, watch, onMounted } from 'vue'

export default {
  components: {
    MultiSelect,
  },

  props: {
    modelValue: { type: Array, default: [] },
    value: { type: String },
    options: {
      type: Array,
      default: [],
    },
    id: {
      type: String,
    },
    error: String,
    appendTo: String | HTMLElement,
    required: String,
    label: String,
    optionLabel: {
      type: String,
      default: 'label'
    }
  },

  emit: ['select'],

  setup( props, context ) {
    const selected = ref( null )

    const getSelectedOption = () => {
      if ( props.modelValue && typeof( props.modelValue[ 0 ] ) === 'object' ) {
        selected.value = props.modelValue
        return
      }

      selected.value = props.options.filter( option => props.modelValue?.includes( option?.value ) )
    }

    watch( () => props.modelValue, () => getSelectedOption() )

    onMounted( () => {
      watch(() => props.options, () => getSelectedOption(), {
        immediate: true
      } )
    } )


    const handleChangeSelect = () => {
      const selecionados = selected.value.map(x => x.value);
      context.emit('update:modelValue', selecionados)
      context.emit('select', selecionados)
    }

    const clearSelects = () => {
      selected.value = []
    }

    return { selected, clearSelects, handleChangeSelect }
  },
}
</script>
<style>
.p-multiselect, .p-multiselect-filter {
    height: 43px;
}
.p-multiselect-label {
    padding: 0.5rem 0.5rem !important;
}
</style>
